module.exports = __webpack_public_path__ + "img/pt.b2290d68.png";